import React, { useCallback } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List } from 'react-window';

interface VirtualizedListProps<T> {
  items: T[];
  renderItem: (props: { index: number; style: React.CSSProperties; data: T[] }) => React.ReactElement | null;
  itemHeight?: number;
  className?: string;
}

export function VirtualizedList<T>({
  items,
  renderItem,
  itemHeight = 80,
  className,
}: VirtualizedListProps<T>) {
  const Row = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const item = items[index];

      if (!item) {
        return null;
      }

      return renderItem({ index, style, data: items });
    },
    [items, renderItem]
  );

  return (
    <div className={`h-full w-full ${className || ''}`}>
      <AutoSizer>
        {({ height, width }) => (
          <List
            className="divide-y divide-border"
            height={height}
            width={width}
            itemCount={items.length}
            itemSize={itemHeight}
          >
            {Row}
          </List>
        )}
      </AutoSizer>
    </div>
  );
} 